import { createRoot } from 'react-dom/client'

import { loadPublicConfig } from './lib/publicConfig'
import './styles/global.css'

const container = document.getElementById('root')
if (!(container instanceof HTMLElement)) {
  throw new Error('The application root element is missing from index.html')
}

void loadPublicConfig()
  .then(() => import('./app/AppRoot'))
  .then(({ AppRoot }) => {
    createRoot(container).render(<AppRoot />)
  })
  .catch((error: unknown) => {
    const message = error instanceof Error ? error.message : 'The application could not load its public configuration'
    container.replaceChildren()
    const paragraph = document.createElement('p')
    paragraph.textContent = message
    container.appendChild(paragraph)
  })
